<template>
  <div class="header-row">
    <div class="subscription-col"></div>
    <div class="subscription-col">
      Email
    </div>
    <div class="subscription-col">
      Notification
    </div>
  </div>
</template>

<script>
export default {
  
}
</script>

